  <template>
    <!--    :class="{ 'raffle&#45;&#45;rolling': isRolling }"-->
    <div
      :class="raffleClass"
      class="raffle"
    >
      <div class="raffle__top">
        <div class="md:hidden block absolute -top-6 -right-20 -rotate-[30deg] z-20">
          <DefaultStickerCTA/>
        </div>
        <div class="raffle__head flex flex-col justify-center items-center">
          <div class="mt-9 text-center">
            <div class="text-xs font-bold">
              {{ $t('raffle.copy-countdown') }}
            </div>
            <div class="raffle__countdown text-2xl sm:text-[28px] font-black flex gap-px justify-center">
              <div class="countdown-unit">{{ countdownString.days }}</div>
              <div class="countdown-separator">:</div>
              <div class="countdown-unit">{{ countdownString.hours }}</div>
              <div class="countdown-separator">:</div>
              <div class="countdown-unit">{{ countdownString.minutes }}</div>
              <div class="countdown-separator">:</div>
              <div class="countdown-unit">{{ countdownString.seconds }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="raffle__gradient-border raffle__gradient-border--body">
        <div class="raffle__body">
          <div class="raffle__inner">
            <div class="h4 raffle__heading raffle__heading--over-drums">
              {{ $t('raffle.heading-draw') }}
            </div>
            <div class="raffle__drums">

              <div class="relative flex gap-2.5 z-10 overflow-visible">
                <div class="raffle__gradient-border raffle__gradient-border--drums-container">
                  <div class="raffle__drums-container">
                    <div class="raffle__gradient-border raffle__gradient-border--drum">
                      <div class="raffle__drum">
                        <div class="raffle__drum-bg"></div>
                        <DefaultRaffleNumbers
                          :static="getWinningPsc(1)"
                        />
                      </div>
                    </div>
                    <div class="raffle__gradient-border raffle__gradient-border--drum">
                      <div class="raffle__drum">
                        <div class="raffle__drum-bg"></div>
                        <DefaultRaffleNumbers
                          :static="getWinningPsc(2)"
                        />
                      </div>
                    </div>
                    <div class="raffle__gradient-border raffle__gradient-border--drum">
                      <div class="raffle__drum">
                        <div class="raffle__drum-bg"></div>
                        <DefaultRaffleNumbers
                          :static="getWinningPsc(3)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="raffle__gradient-border raffle__gradient-border--drums-container">
                  <div class="raffle__drums-container raffle__drums-container--right">
                    <div class="raffle__gradient-border raffle__gradient-border--drum">
                      <div class="raffle__drum">
                        <div class="raffle__drum-bg"></div>
                        <DefaultRaffleNumbers
                          :static="getWinningPsc(4)"
                        />
                      </div>
                    </div>
                    <div class="raffle__gradient-border raffle__gradient-border--drum">
                      <div class="raffle__drum">
                        <div class="raffle__drum-bg"></div>
                        <DefaultRaffleNumbers
                          :static="getWinningPsc(5)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="absolute -left-2 top-1/2 -translate-y-1/2 w-6 z-[9999]">
                <svg viewBox="0 0 22 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M11.7061 0.813869C11.3261 0.357883 10.7633 0.0942383 10.1697 0.0942383H2.10645C1.00188 0.0942383 0.106445 0.989669 0.106445 2.09424V22.0942C0.106445 23.1988 1.00188 24.0942 2.10645 24.0942H10.1697C10.7633 24.0942 11.3262 23.8306 11.7061 23.3746L20.0395 13.3746C20.6575 12.6329 20.6575 11.5556 20.0395 10.8139L11.7061 0.813869Z"/>
                  <path
                    d="M10.0395 4.81387C9.65948 4.35788 9.09659 4.09424 8.50303 4.09424H5.10645C4.00188 4.09424 3.10645 4.98967 3.10645 6.09424V18.0942C3.10645 19.1988 4.00188 20.0942 5.10645 20.0942H8.50303C9.09659 20.0942 9.65948 19.8306 10.0395 19.3746L15.0395 13.3746C15.6575 12.6329 15.6575 11.5556 15.0395 10.8139L10.0395 4.81387Z"
                    fill="white"/>
                  <circle cx="2" cy="2" r="2" transform="matrix(-1 0 0 1 10.1064 10.0942)" fill="#18181B"/>
                </svg>
              </div>
              <div class="absolute -right-2 top-1/2 -translate-y-1/2 w-6 z-[999] rotate-180">
                <svg viewBox="0 0 22 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M11.7061 0.813869C11.3261 0.357883 10.7633 0.0942383 10.1697 0.0942383H2.10645C1.00188 0.0942383 0.106445 0.989669 0.106445 2.09424V22.0942C0.106445 23.1988 1.00188 24.0942 2.10645 24.0942H10.1697C10.7633 24.0942 11.3262 23.8306 11.7061 23.3746L20.0395 13.3746C20.6575 12.6329 20.6575 11.5556 20.0395 10.8139L11.7061 0.813869Z"/>
                  <path
                    d="M10.0395 4.81387C9.65948 4.35788 9.09659 4.09424 8.50303 4.09424H5.10645C4.00188 4.09424 3.10645 4.98967 3.10645 6.09424V18.0942C3.10645 19.1988 4.00188 20.0942 5.10645 20.0942H8.50303C9.09659 20.0942 9.65948 19.8306 10.0395 19.3746L15.0395 13.3746C15.6575 12.6329 15.6575 11.5556 15.0395 10.8139L10.0395 4.81387Z"
                    fill="white"/>
                  <circle cx="2" cy="2" r="2" transform="matrix(-1 0 0 1 10.1064 10.0942)" fill="#18181B"/>
                </svg>
              </div>
            </div>

            <DefaultRaffleDrumLoginFooter
              v-if="props.type === UserGameState.DEFAULT"
              :is-loading="logout"
              @login="login"
              @register="register"
            />

            <div
              v-if="props.type === UserGameState.FIRSTGAME"
              class="raffle__footer"
            >
              <div class="h5 raffle__heading">
                {{ $t('raffle.heading-first-game') }}
              </div>
              <div class="text-xs font-medium pt-1">
                {{ $t('raffle.copy-first-game') }}
              </div>
            </div>

            <div
              v-if="props.type === UserGameState.USERLOGGED || props.type === UserGameState.USERLOGGEDLASTMINUTE || props.type === UserGameState.USERLOGGEDDRAW"
              class="raffle__footer"
            >
              <button
                class="btn btn--primary btn--shadow"
                @click="openPscModal"
              >
                {{ $t('raffle.btn-fill-play') }}
              </button>
              <div class="text-xs font-medium pt-4">
                {{ $t('raffle.copy-play') }}
              </div>
            </div>

            <div
              v-if="props.type === UserGameState.USERINGAME"
              class="raffle__footer"
            >
              <button
                class="btn btn--secondary btn--shadow btn--cursor-none"
              >
                <DefaultIconsCheckmark/>
                {{ $t('raffle.btn-joined') }} {{ formatedDrawTime }}
              </button>
              <div class="text-xs font-medium pt-4">
                {{ $t('raffle.copy-play') }}
              </div>
            </div>

            <DefaultRaffleDrumLoginFooter
              v-if="props.type === UserGameState.LASTMINUTE"
              :is-loading="logout"
              @login="login"
              @register="register"
            />

            <div
              v-if="props.type === UserGameState.USERLASTMINUTE"
              class="raffle__footer"
            >
              <button
                class="btn btn--secondary btn--shadow btn--locked"
              >
                <DefaultIconsCheckmark/>
                {{ $t('raffle.btn-joined') }} {{ formatedDrawTime }}
                <!-- ({{ countdownButtonString }}) -->
              </button>
              <div class="text-xs font-medium pt-4">
                {{ $t('raffle.copy-play') }}
              </div>
            </div>

            <DefaultRaffleDrumLoginFooter
              v-if="props.type === UserGameState.DRAW"
              :is-loading="logout"
              @login="login"
              @register="register"
            />

            <div
              v-if="props.type === UserGameState.USERDRAW"
              class="raffle__footer"
            >
              <button
                @click="checkWin"
                :class="{ 'btn--loading': isLoading }"
                class="btn btn--primary btn--shadow"
              >
                {{ $t('raffle.btn-find-out') }}
              </button>
              <div class="text-xs font-medium pt-4">
                {{ $t('raffle.copy-play') }}
              </div>
            </div>

            <div
              v-if="props.type === UserGameState.USERWIN"
              class="raffle__footer"
            >
              <div class="h5 raffle__heading">
                {{ $t('raffle.heading-win') }} {{ currency.toCurrency(prize) }}!
              </div>
              <div class="text-xs font-medium pt-1">
                {{ $t('raffle.copy-win') }}
              </div>
              <button
                class="btn btn--primary btn--shadow mt-4"
                @click="openWinningModal"
              >
                {{ $t('raffle.btn-win') }}
              </button>
            </div>

            <div
              v-if="props.type === UserGameState.USERCLAIMED"
              class="raffle__footer"
            >
              <div class="h5 raffle__heading">
                {{ $t('raffle.heading-win') }} {{ currency.toCurrency(prize) }}!
              </div>
              <div class="text-xs font-medium pt-1">
                {{ $t('raffle.copy-win') }}
              </div>
              <button
                class="btn btn--disabled mt-4"
              >
                {{ $t('raffle.btn-win-claimed') }}
              </button>
            </div>

            <div
              v-if="props.type === UserGameState.USERALMOSTWIN"
              class="raffle__footer"
            >
              <div class="h5 raffle__heading">
                {{ $t('raffle.heading-almost-win') }}
              </div>
              <div class="text-xs font-medium pt-1">
                {{ $t('raffle.copy-almost-win') }}
              </div>
              <div class="text-xs font-semibold mt-2">
                {{ $t('raffle.copy-try-again') }}
              </div>
            </div>
            <div
              v-if="props.type === UserGameState.USERLOST"
              class="raffle__footer"
            >
              <div class="h5 raffle__heading">
                {{ $t('raffle.heading-lost') }}
              </div>
              <div class="text-xs font-medium pt-1">
                {{ $t('raffle.copy-lost') }}
              </div>
            </div>
            <div
              v-if="props.type === UserGameState.NOGAME"
              class="raffle__footer"
            >
              <div class="h5 raffle__heading">
                {{ $t('raffle.heading-no-game') }}
              </div>
              <div class="text-xs font-medium pt-1">
                {{ $t('raffle.copy-no-game') }}
              </div>
            </div>

            <div v-if="errorMessage" class="text-sm font-medium error-message">
              {{ errorMessage }}
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="props.type === UserGameState.FIRSTGAME"
        class="box p-6 mt-2 w-full"
      >
        <div class="text-md font-bold mb-1">{{ $t('raffle.box-heading-first-game') }}</div>
        <p class="text-xs">{{ $t('raffle.box-copy-first-game') }} {{ formatedNextChance }}</p>
      </div>

      <div
        v-if="props.type === UserGameState.USERLOGGED"
        class="box p-6 mt-2 w-full"
      >
        <div class="text-md font-bold mb-1">{{ $t('raffle.heading-fill') }}</div>
        <p class="text-xs">{{ $t('raffle.copy-fill') }}</p>
      </div>

      <div
        v-if="props.type === UserGameState.USERWIN || props.type === UserGameState.USERALMOSTWIN || props.type === UserGameState.USERCLAIMED || props.type === UserGameState.USERLOST"
        class="box p-6 mt-2 w-full"
      >
        <div class="text-md font-bold mb-1">{{ $t('raffle.heading-next-chance') }}</div>
        <p class="text-xs">{{ $t('raffle.copy-next-chance') }} {{ formatedNextChance }}</p>
      </div>

      <!-- logout iframe -->
      <div v-if="logout" class="w-0 h-0 hidden">
        <iframe :src="ssoLogoutUrl" ref="logoutIframe"></iframe>
      </div>

    </div>
  </template>

  <style lang="scss">
  </style>

  <script setup lang="ts">
  import { defineProps, defineEmits, type PropType } from 'vue'
  import UserGameState from "~/libs/constants/UserGameState"
  import {useI18n} from "vue-i18n";
  import {pushToDataLayer} from "~/composables/useAnalytics";
  const {t} = useI18n()
  const route = useRoute()
  const config = useRuntimeConfig()
  // Hidden iframe used by register() to end the Sentinel SSO session before a fresh login.
  // Points at our Nitro logout route which performs the proper Sentinel end-session (with id_token_hint).
  const ssoLogoutUrl = String(config.public?.ssoLogoutPath || '/auth/sso/logout')
  const logoutTimeoutMs = Number(config.public?.logoutTimeoutMs || 1000)

  const props = defineProps({
    type: {type: String as PropType<UserGameState>, required: false, default: UserGameState.DEFAULT},
    countdown: {type: Date, required: false},
    nextChance: {type: Date, required: false},
    drawDate: {type: Date, required: false},
    prize: {type: Number, required: false},
    psc: {type: String, required: false},
    isLoading: {type: Boolean, required: false, default: false},
    errorMessage: { type: String, required: false, default: undefined },
  })

  const emits = defineEmits(['open:pscModal', 'open:winningModal', 'checkWin'])

  const currency = useCurrency()

  const logout = ref(false)
  const logoutIframe = ref()

  const openPscModal = () => {
    emits('open:pscModal')
  }

  const openWinningModal = () => {
    emits('open:winningModal')
  }

  const formatedNextChance = computed(() => {
    if (!props.nextChance) {
      return null
    }
    const nc = props.nextChance
    let textIn = t('raffle.copy-next-chance-in')
    if (nc.getHours() > 11 && nc.getHours() < 15) {
      textIn = t('raffle.copy-next-chance-inn')
    }
    return `${addZeros(nc.getDate())}. ${addZeros(nc.getMonth() + 1)}. ${nc.getFullYear()} ${textIn} ${addZeros(nc.getHours())}:${addZeros(nc.getMinutes())}.`
  })

  const formatedDrawTime = computed(() => {
    if (!props.drawDate) {
      return null
    }
    const dt = props.drawDate
    const hours = dt.getHours()
    let translateKey
    switch (hours) {
      case 0:
      case 1:
        translateKey = 'raffle.draw-info-hour'
        break
      case 2:
      case 3:
      case 4:
        translateKey = 'raffle.draw-info-hours'
        break
      case 5:
      case 6:
      case 7:
      case 8:
      case 9:
      case 10:
      case 11:
        translateKey = 'raffle.draw-info-hour'
        break
      case 12:
      case 13:
      case 14:
        translateKey = 'raffle.draw-info-hours'
        break
      case 15:
      case 16:
      case 17:
      case 18:
      case 19:
        translateKey = 'raffle.draw-info-hour'
        break
      case 20:
      case 21:
      case 22:
      case 23:
      default:
        translateKey = 'raffle.draw-info-hours'
        break
    }

    return t(translateKey, {
      drawTime: `${addZeros(dt.getHours())}:${addZeros(dt.getMinutes())}`,
    })
  })

  const addZeros = (num: number) => {
    return ('0' + num).slice(-2)
  }

  const countdownButtonString = computed(() => {
    let cd = `${countdownString.value.minutes}:${countdownString.value.seconds}`
    if (Number(countdownString.value.hours) > 0) {
      cd = `${countdownString.value.hours}:${cd}`
    }
    return cd
  })

  const raffleClass = computed(() => {
    switch (props.type) {
      case UserGameState.FIRSTGAME:
        return 'raffle--first-game'
      case UserGameState.USERFIRSTGAME:
        return 'raffle--user-first-game'
      case UserGameState.USERLOGGED:
        return 'raffle--user-logged'
      case UserGameState.USERLOGGEDLASTMINUTE:
        return 'raffle--user-logged-last-minute'
      case UserGameState.USERINGAME:
        return 'raffle raffle--user-in-game'
      case UserGameState.LASTMINUTE:
        return 'raffle--last-minute'
      case UserGameState.USERLASTMINUTE:
        return 'raffle--user-last-minute'
      case UserGameState.DRAW:
        return 'raffle--draw'
      case UserGameState.USERDRAW:
        return 'raffle--draw'
      case UserGameState.USERLOGGEDDRAW:
        return 'raffle--user-logged-draw'
      case UserGameState.USERLOST:
        return 'raffle--user-lost'
      case UserGameState.USERALMOSTWIN:
        return 'raffle--user-almost-win'
      case UserGameState.USERWIN:
        return 'raffle--user-win'
      case UserGameState.USERCLAIMED:
        return 'raffle--user-claimed'
      case UserGameState.NOGAME:
        return 'raffle--no-game'
      case UserGameState.DEFAULT:
      default:
        return ''
    }
  })

  const countdownString = computed(() => {
    let countdown = { days: "—", hours: "—", minutes: "—", seconds: "—" }
    if (import.meta.server) {
      return countdown
    }
    let diff = 0

    if (props.countdown) {
      diff = props.countdown.getTime() / 1000
      const seconds = Math.max(Math.floor(diff % 60), 0)
      const minutes = Math.max(Math.floor((diff - seconds) / 60 % 60 ), 0)
      const hours = Math.max(Math.floor((diff - seconds - (minutes * 60)) / 60 / 60 % 24 ), 0)
      const days = Math.max(Math.floor((diff - seconds - (minutes * 60) - (hours * 60 * 60)) / 60 / 60 / 24), 0)

      countdown = {
        days: ('0' + days).slice(-2),
        hours: ('0' + hours).slice(-2),
        minutes: ('0' + minutes).slice(-2),
        seconds: ('0' + seconds).slice(-2)
      }
    }

    switch (props.type) {
      case UserGameState.USERLOGGED:
      case UserGameState.USERINGAME:
      case UserGameState.LASTMINUTE:
      case UserGameState.USERLASTMINUTE:
      case UserGameState.USERLOGGEDLASTMINUTE:
      case UserGameState.DEFAULT:
        return countdown
      case UserGameState.FIRSTGAME:
      case UserGameState.USERLOST:
      case UserGameState.USERALMOSTWIN:
      case UserGameState.USERWIN:
      case UserGameState.DRAW:
      case UserGameState.USERDRAW:
      case UserGameState.USERLOGGEDDRAW:
      case UserGameState.USERCLAIMED:
        return { days: "00", hours: "00", minutes: "00", seconds: "00" }
      case UserGameState.NOGAME:
      default:
        return { days: "—", hours: "—", minutes: "—", seconds: "—" }
    }
  })

  const getWinningPsc = (position: number): string | undefined => {
    switch (props.type) {
      case UserGameState.USERLOGGED:
      case UserGameState.USERINGAME:
      case UserGameState.LASTMINUTE:
      case UserGameState.USERLASTMINUTE:
      case UserGameState.DRAW:
      case UserGameState.USERDRAW:
      case UserGameState.USERLOGGEDLASTMINUTE:
      case UserGameState.USERLOGGEDDRAW:
      case UserGameState.DEFAULT:
        return undefined
      case UserGameState.FIRSTGAME:
      case UserGameState.USERLOST:
      case UserGameState.USERALMOSTWIN:
      case UserGameState.USERWIN:
      case UserGameState.USERCLAIMED:
        return props.psc?.substring(position-1, position)
      case UserGameState.NOGAME:
      default:
        return String('------').substring(position-1, position)
    }
  }

  const checkWin = () => {
    if (!props.isLoading) {
      emits('checkWin')
    }
  }

  const login = async (afterRegistration: boolean = false) => {
    // --- ANALYTIKA PRO LOGIN START ---
    if (!afterRegistration)  {
      pushToDataLayer({
        "event": "user_login_start"
      });
    }
    // ---------------------------------

    const request = useRequestURL()
    let customLoginPath = config.public.autoLoginUrl || '/auth/login'
    let loginUrl = `${request.protocol}//${request.host}${customLoginPath}`

    const loginCallbackUrl = route.query.loginCallbackUrl ? route.query.loginCallbackUrl as string : undefined

    if (loginCallbackUrl) {
      loginUrl = `${loginUrl}?loginCallbackUrl=${loginCallbackUrl}`
    }

    // Sentinel sends `frame-ancestors 'self'`, so it refuses to render inside any
    // iframe - break the whole tab out instead of navigating just the iframe.
    if (import.meta.client && window.self !== window.top) {
      window.top!.location.href = loginUrl
      return
    }

    navigateTo(loginUrl, { external: true })
  }

  const register = async () => {
    // --- ANALYTIKA PRO REGISTER START ---
    pushToDataLayer({
      "event": "user_registration_start"
    });
    // show logout iframe
    logout.value = true
    // wait to external logout, then ty to login again
    setTimeout(() => {
      login(true)
    }, logoutTimeoutMs)
  }
  </script>
